// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"436":"cae659b5","642":"a789ee9c"}[chunkId] + ".css";
};